import React, { useState } from 'react';
import { saveLead } from '../services/leadService';
import { Link } from 'react-router-dom';
const BookFreeDemoClass = () => {

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    course: '',
    preferredDate: '',
    preferredTime: '',
    type: 'free_demo_class',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await saveLead({
        ...formData,
        source: 'book_free_demo_class',
        timestamp: new Date().toISOString(),
      });
      setIsSuccess(true);
      setFormData({
        name: '',
        phone: '',
        email: '',
        course: '',
        preferredDate: '',
        preferredTime: '',
      });
    } catch (error) {
      console.error('Error saving lead:', error);
      alert('Thank you for your booking! We will contact you soon to confirm.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      
      {/* Hero Section */}
      <section className="pt-32 pb-14 md:pb-20 bg-white border-b border-[#ececec]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center fade-in">
            <h1 className="text-4xl md:text-5xl font-bold text-black mb-4">Book Free Demo Class</h1>
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed">
              Experience our teaching methodology and get a taste of our training programs
            </p>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-14 md:py-20 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-2xl mx-auto">
            {isSuccess ? (
              <div className="premium-card p-10 text-center slide-up">
                <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-green-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-black mb-2">Booking Successful!</h2>
                <p className="text-gray-600 mb-6 text-base leading-relaxed">
                  We've received your demo class request. Our team will contact you shortly to
                  confirm your demo class slot.
                </p>
                <Link
                  to="/courses"
                  className="btn-primary"
                >
                  Explore Our Courses
                </Link>
              </div>
            ) : (
              <div className="premium-card p-8 md:p-10 slide-up">
                <h2 className="text-2xl md:text-3xl font-bold text-black mb-6">Fill in Your Details</h2>
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-black mb-2">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-[#ececec] rounded-xl focus:ring-2 focus:ring-[#D6001C] focus:border-transparent transition-all duration-300 shadow-sm"
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-semibold text-black mb-2">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-[#ececec] rounded-xl focus:ring-2 focus:ring-[#D6001C] focus:border-transparent transition-all duration-300 shadow-sm"
                      placeholder="Enter your phone number"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-black mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-[#ececec] rounded-xl focus:ring-2 focus:ring-[#D6001C] focus:border-transparent transition-all duration-300 shadow-sm"
                      placeholder="Enter your email address"
                    />
                  </div>

                  <div>
                    <label htmlFor="course" className="block text-sm font-semibold text-black mb-2">
                      Course of Interest *
                    </label>
                    <select
                      id="course"
                      name="course"
                      required
                      value={formData.course}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-[#ececec] rounded-xl focus:ring-2 focus:ring-[#D6001C] focus:border-transparent transition-all duration-300 shadow-sm"
                    >
                      <option value="">Select course</option>
                      <option value="IELTS">IELTS</option>
                      <option value="OET">OET</option>
                      <option value="PTE">PTE</option>
                      <option value="DET">Duolingo English Test (DET)</option>
                      <option value="Spoken English">Spoken English</option>
                    </select>
                  </div>

                  <div>
                    <label
                      htmlFor="preferredDate"
                      className="block text-sm font-semibold text-black mb-2"
                    >
                      Preferred Date
                    </label>
                    <input
                      type="date"
                      id="preferredDate"
                      name="preferredDate"
                      value={formData.preferredDate}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-[#ececec] rounded-xl focus:ring-2 focus:ring-[#D6001C] focus:border-transparent transition-all duration-300 shadow-sm"
                      min={new Date().toISOString().split('T')[0]}
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="preferredTime"
                      className="block text-sm font-semibold text-black mb-2"
                    >
                      Preferred Time
                    </label>
                    <select
                      id="preferredTime"
                      name="preferredTime"
                      value={formData.preferredTime}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-[#ececec] rounded-xl focus:ring-2 focus:ring-[#D6001C] focus:border-transparent transition-all duration-300 shadow-sm"
                    >
                      <option value="">Select time</option>
                      <option value="morning">Morning (9 AM - 12 PM)</option>
                      <option value="afternoon">Afternoon (12 PM - 4 PM)</option>
                      <option value="evening">Evening (4 PM - 7 PM)</option>
                    </select>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full btn-primary"
                  >
                    {isSubmitting ? 'Submitting...' : 'Book Free Demo Class'}
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default BookFreeDemoClass;
